import { equals } from 'ramda';

import { type TJsonQuery } from '@/packages/JsonQuery';

export const isGeoChanged = (prevFilters: TJsonQuery, newFilters: TJsonQuery): boolean => {
  return (
    !equals(prevFilters.geo?.value, newFilters.geo?.value) ||
    !equals(prevFilters.region?.value, newFilters.region?.value) ||
    (Boolean(prevFilters.bbox) && !newFilters.bbox)
  );
};
